/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_List_HintInputs */

const cs_viewings_list_hint = /** @type {(inputs: Viewings_List_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prohlídky napříč kanceláří — vyhledejte a vyberte nemovitost a klienta.`)
};

const en_viewings_list_hint = /** @type {(inputs: Viewings_List_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property viewings across the office — search and pick property + client to schedule.`)
};

/**
* | output |
* | --- |
* | "Property viewings across the office — search and pick property + client to schedule." |
*
* @param {Viewings_List_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_list_hint = /** @type {((inputs?: Viewings_List_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_List_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_list_hint(inputs)
	return cs_viewings_list_hint(inputs)
});